<template>
  <div
    class="checkbox-input"
    :class="{
      'checkbox-input--error': errors.length > 0,
      [`checkbox-input--${view}`]: true,
    }"
  >
    <input
      type="checkbox"
      v-model="isChecked"
      @change="processInput"
      :id="uniqueID"
      :readonly="readonly"
    />
    <label :for="uniqueID" class="checkbox-input__label">
      <span class="checkbox-input__mark"></span>
      <span class="checkbox-input__text">{{ text }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "CheckboxInput",
  model: {
    prop: "value",
    event: "update",
  },
  props: {
    text: {
      type: String,
    },
    value: [Boolean],
    view: {
      type: String,
      default: "base",
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uniqueID: "",
      isChecked: false,
    };
  },
  created() {
    this.isChecked = !!this.value || false;
    this.uniqueID = Math.random().toString(36).substr(2, 9);
  },
  watch: {
    value: function () {
      this.isChecked = this.value;
    },
  },
  methods: {
    processInput() {
      if (!this.readonly) {
        console.log(123);
        this.$emit("update", this.isChecked);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
.checkbox-input {
  display: flex;
  align-items: center;

  input {
    display: none;
  }

  input:checked + .checkbox-input__label & {
    &__mark:before {
      opacity: 1;
    }
  }

  &__label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__mark {
    position: relative;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #f0f3fa;
    margin-right: 12px;
    border-radius: 6px;

    &:before {
      content: "";
      position: absolute;
      width: 14px;
      height: 14px;
      top: 1px;
      left: 1px;

      display: block;
      opacity: 0;
      transition: opacity 0.1s linear;
      background-color: $action;
      border-radius: 4px;
    }
  }

  &__text {
    font-size: pxToRem(12);
    line-height: pxToRem(19);
    color: $text;
  }

  &--error & {
    &__mark {
      border-color: $red;
    }

    &__text {
      color: $red;
    }
  }
}
</style>
